import React from 'react';
import { useParams } from 'react-router-dom';
import services from '../components/data/services';

const ServiceDetail = () => {
    const { id } = useParams();
    const service = services.find((s) => s.id === id);

    if (!service) {
        return <h2>Service not found!</h2>;
    }

    return (
        <div style={{ padding: '20px' }}>
            <h1>{service.title}</h1>
            <img
                src={service.image}
                alt={service.title}
                style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }}
            />
            <p>{service.description}</p>
            <button
                onClick={() =>
                    window.location.href = `https://wa.me/916354311491?text=I%20want%20to%20know%20more%20about%20${service.title}`
                }
                style={{
                    backgroundColor: '#40E0D0',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                Contact Us
            </button>
        </div>
    );
};

export default ServiceDetail;
